export default __webpack_public_path__ + "static/media/4.7915b996.png";